import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { GallerySection } from '../components/GallerySection';
export function GalleryPage() {
  return <>
      <PageBanner title="Style Gallery" subtitle="A glimpse into the artistry and precision of our master braiders." backgroundImage="https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp" data-id="element-358" />
      <GallerySection showAll data-id="element-359" />
    </>;
}